import {useState} from "react";
import {Avatar, Box} from "@mui/material";
import {Blurhash} from "react-blurhash";

const BlurhashAvatar = ({
                            src,
                            blurhash,
                            size = 60,
                            sx,
                            ...props
                        }) => {
    const [loaded, setLoaded] = useState(false);

    return (
        <Box
            sx={{
                width: size,
                height: size,
                position: "relative", // Ensure this is the anchor for absolute children
                borderRadius: "50%",
                overflow: "hidden",
                flexShrink: 0, // Prevents the circle from being squashed in flexbox layouts
                ...sx,
            }}
        >
            {/* Blurhash Placeholder */}
            {!loaded && blurhash && (
                <Blurhash
                    hash={blurhash}
                    width="100%"
                    height="100%"
                    resolutionX={32}
                    resolutionY={32}
                    punch={1}
                />
            )}

            {/* Actual Image */}
            <Avatar
                {...props}
                src={src}
                imgProps={{
                    onLoad: () => setLoaded(true),
                    style: {
                        objectFit: "cover", // Forces the image to fill while keeping ratio
                    }
                }}
                sx={{
                    width: "100%",
                    height: "100%",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: loaded ? 1 : 0,
                    transition: "opacity 200ms ease",
                    bgcolor: "transparent",
                }}
            />
        </Box>
    );
};

export default BlurhashAvatar;